import "./GeneralFindingsTable.css";
import React from "react";

function GeneralFindingsTable(props) {
  const data = props.data;
  const columns = props.columns;
  const year = props.data[0]["Έτος"];
  const airports = props.airports;

  // Specify the name of the column you want to move to the left
  const specificColumn = "Μονάδα Λήψης Απόφασης - Αεροδρόμιο";

  // Move the specific column to the front of the columns array
  const rearrangedColumns = [
    specificColumn,
    ...columns.filter((col) => col !== specificColumn),
  ];

  // Function to map airport codes to full airport names
  const getAirportName = (code) => {
    const airport = airports.find((item) => item.endsWith(code));
    return airport ? airport : code;
  };

  return (
    <div style={{ marginTop: "50px" }}>
      {console.log("in table : ", data)}
      <p
        style={{
          fontSize: " 0.8em",
          color: "gray",
          marginTop: "10px",
          marginLeft: "10px",
          marginBottom: "3px",
        }}
      >
        Μετρήσεις έτους ({year})
      </p>
      <div style={{ border: "1px solid #ccc", overflowX: "auto" }}>
        <div style={{ margin: "20px" }}>
          <table className="table">
            <thead>
              <tr>
                {rearrangedColumns.map((key) => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  {rearrangedColumns.map((column) => (
                    <td key={column}>
                      {column === specificColumn
                        ? getAirportName(item[column])
                        : item[column]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default GeneralFindingsTable;
